// 引导storage
import { CONST_STORAGE_PREFIX } from '@/common/constant'

export const guideKey = `${CONST_STORAGE_PREFIX}GUIDE_FLAG`

export function getGuide () {
  return !!sessionStorage.getItem(guideKey)
}

export function setGuide (val = true) {
  sessionStorage.setItem(guideKey, val)
}
